import { validations } from './validations';
import * as _ from 'lodash';


export const getValidationByKey = (key: string) => {
  return _.find(validations, {key});
};

export const getValidationByName = (name: string) => {
  return _.find(validations, {name});
};
